import React from "react";
import { Row, Col ,MenuItem ,DropdownButton ,ButtonToolbar,Button,Grid,ToggleButtonGroup,ToggleButton } from 'react-bootstrap'

class ShopSort extends React.Component {
render() {
return (
<div className="shopsort products">
        
                <DropdownButton
                    bsSize="large"
                    title="Sort By : Default Sorting"
                    id="dropdown-size-large"
                    >
                    <MenuItem eventKey="1">Action</MenuItem>
                    <MenuItem eventKey="2">Another action</MenuItem>
                    <MenuItem eventKey="3">Something else here</MenuItem>
                    <MenuItem divider />
                    <MenuItem eventKey="4">Separated link</MenuItem>
                </DropdownButton>
                <DropdownButton
                    bsSize="large"
                    title="Show : 12 Items Page"
                    id="dropdown-size-large"
                    >
                    <MenuItem eventKey="1">Action</MenuItem>
                    <MenuItem eventKey="2">Another action</MenuItem>
                    <MenuItem eventKey="3">Something else here</MenuItem>
                    <MenuItem divider />
                    <MenuItem eventKey="4">Separated link</MenuItem>
                </DropdownButton>
<div className="products_switch">


         <ToggleButtonGroup type="radio" name="options" defaultValue={1}>
      <ToggleButton value={1} onClick={()=>{this.props.settingView('grid')}} ><i class="material-icons" >
view_module
</i></ToggleButton>


      <ToggleButton value={2} onClick={()=>{this.props.settingView('list')}}><i class="material-icons">
view_list
</i></ToggleButton>
    </ToggleButtonGroup>
    </div>



    <div>
    </div>

</div>
);
}
}
export default ShopSort;


// WEBPACK FOOTER //
// ./src/Components/ShopSort/ShopSort.jsx